module.exports = __webpack_public_path__ + "static/img/jzxtb.be823444.png";